import { useEffect, useState, forwardRef, useImperativeHandle, useRef, createContext, useContext } from 'react';

import CainoholdemGameBoard from "./NewUI/CasinoholdemGameBoard";
import user_img from "../../../../../assets/games/CasinoHoldem/profile_img.png"
import balance_img from "../../../../../assets/games/CasinoHoldem/balance_img.png"
import betChip_img from "../../../../../assets/games/CasinoHoldem/betChip_img.png"
import winCup_img from "../../../../../assets/games/CasinoHoldem/winCup_img.png"

import './NewUI/NewCasinoHold.scss'

import './NewUI/BonusPopup.scss'
import { FaBars } from "react-icons/fa";
import CasinoholdemGameControllers from './NewUI/CasinoholdemGameControllers';
import OptionsMenu from '../../../../../library/OptionsMenuholdem/OptionsMenuholdem';

import muteImgholdem from "../../../../../assets/games/PaiGow/muteImg.png"
import SoundImgholdem from "../../../../../assets/games/PaiGow/SoundImg.png"
import WinAnimation from "../../../Utillitys/WinAnimaion"
import PayoutInfoholdem from '../Casinoholdem/Holdempayout';
import Bonuspopup from "./NewUI/BonusPopup"
import { TRUE } from 'sass';
// 1. Wrap the component in React.forwardRef

const GameRules = [

  { "name": `Casino Hold’em is Orbital’s one of the easiest games, designed with Provably Fair technology that makes the game outcomes totally random.` },
  { "name": ` A 52-card deck is used to play the game. The player places an Ante or blind bet, as well as an optional bonus bet.` },
  { "name": `The main principle of the game is to have a total combination of cards that will beat the dealer’s card.` },
  { "name": `The dealer must have a pair of 4s or better to qualify.` },
  { "name": `If the dealer does not qualify, the Ante bet pays according to the Ante Win paytable and the Raise bet is a push.` },
  { "name": `If the dealer qualifies and the dealer's hand is the same as the player's, all bets are push` },

  { "name": `ANTE Bet Winning Combinations :` },

  {
    name: "Royal Flush (100 to 1)",
    element: (
      <div className="cardholdem-row">
        <div className="card-box red">10 ♥</div>
        <div className="card-box red">J ♥</div>
        <div className="card-box red">Q ♥</div>
        <div className="card-box red">K ♥</div>
        <div className="card-box red">A ♥</div>
      </div>
    ),
  },
  {
    name: "Straight Flush (20 to 1)",
    element: (
      <div className="cardholdem-row">
        <div className="card-box black">10 ♠</div>
        <div className="card-box black">9 ♠</div>
        <div className="card-box black">8 ♠</div>
        <div className="card-box black">7 ♠</div>
        <div className="card-box black">6 ♠</div>
      </div>
    ),
  },
  {
    name: "Four of a Kind (10 to 1)",
    element: (
      <div className="cardholdem-row">
        <div className="card-box red">Q ♦</div>
        <div className="card-box black">Q ♣</div>
        <div className="card-box red">Q ♥</div>
        <div className="card-box black">Q ♠</div>
        <div className="cardwhiteholdem red">6 ♦</div>
      </div>
    ),
  },
  {
    name: "Full House (3 to 1)",
    element: (
      <div className="cardholdem-row">
        <div className="card-box red">Q ♦</div>
        <div className="card-box black">Q ♣</div>
        <div className="card-box black">2 ♠</div>
        <div className="card-box red">2 ♥</div>
        <div className="card-box red">2 ♦</div>
      </div>
    ),
  },
  {
    name: "Flush (2 to 1)",
    element: (
      <div className="cardholdem-row">
        <div className="card-box red">2 ♥</div>
        <div className="card-box red">10 ♥</div>
        <div className="card-box red">4 ♥</div>
        <div className="card-box red">7 ♥</div>
        <div className="card-box red">A ♥</div>
      </div>
    ),
  },
  {
    name: "Straight (1 to 1)",
    element: (
      <div className="cardholdem-row">
        <div className="card-box red">2 ♦</div>
        <div className="card-box black">3 ♣</div>
        <div className="card-box black">4 ♠</div>
        <div className="card-box black">5 ♠</div>
        <div className="card-box red">6 ♦</div>
      </div>
    ),
  },
  {
    name: "Three of a Kind (1 to 1)",
    element: (
      <div className="cardholdem-row">
        <div className="card-box red">K ♦</div>
        <div className="card-box black">K ♣</div>
        <div className="card-box black">K ♠</div>
        <div className="cardwhiteholdem red">5 ♠</div>
        <div className="cardwhiteholdem red">9 ♦</div>
      </div>
    ),
  },
  {
    name: "Two pairs (1 to 1)",
    element: (
      <div className="cardholdem-row">
        <div className="card-box red">Q ♦</div>
        <div className="card-box black">Q ♠</div>
        <div className="cardwhiteholdem red">4 ♣</div>
        <div className="card-box red">2 ♠</div>
        <div className="card-box red">2 ♦</div>
      </div>
    ),
  },
  {

    element: (
      <div className="cardholdem-row">
        <div className="card-box red">A ♦</div>
        <div className="card-box red">A ♠</div>
        <div className="cardwhiteholdem red">4 ♣</div>
        <div className="cardwhiteholdem red">1 ♠</div>
        <div className="cardwhiteholdem red">Q ♦</div>
      </div>
    ), name: "Pair of Aces (1 to 1)",
  },

  { "name": `Bonus Bet Winning Combinations :` },

  {
    name: "Royal Flush (100 to 1)",
    element: (
      <div className="cardholdem-row">
        <div className="card-box red">10 ♥</div>
        <div className="card-box red">J ♥</div>
        <div className="card-box red">Q ♥</div>
        <div className="card-box red">K ♥</div>
        <div className="card-box red">A ♥</div>
      </div>
    ),
  },
  {
    name: "Straight Flush (50 to 1)",
    element: (
      <div className="cardholdem-row">
        <div className="card-box black">10 ♠</div>
        <div className="card-box black">9 ♠</div>
        <div className="card-box black">8 ♠</div>
        <div className="card-box black">7 ♠</div>
        <div className="card-box black">6 ♠</div>
      </div>
    ),
  },
  {
    name: "Four of a Kind (40 to 1)",
    element: (
      <div className="cardholdem-row">
        <div className="card-box red">Q ♦</div>
        <div className="card-box black">Q ♣</div>
        <div className="card-box red">Q ♥</div>
        <div className="card-box black">Q ♠</div>
        <div className="cardwhiteholdem red">6 ♦</div>
      </div>
    ),
  },
  {
    name: "Full House (30 to 1)",
    element: (
      <div className="cardholdem-row">
        <div className="card-box red">Q ♦</div>
        <div className="card-box black">Q ♣</div>
        <div className="card-box black">2 ♠</div>
        <div className="card-box red">2 ♥</div>
        <div className="card-box red">2 ♦</div>
      </div>
    ),
  },
  {
    name: "Flush (20 to 1)",
    element: (
      <div className="cardholdem-row">
        <div className="card-box red">2 ♥</div>
        <div className="card-box red">10 ♥</div>
        <div className="card-box red">4 ♥</div>
        <div className="card-box red">7 ♥</div>
        <div className="card-box red">A ♥</div>
      </div>
    ),
  },
  {
    name: "Straight (7 to 1)",
    element: (
      <div className="cardholdem-row">
        <div className="card-box red">2 ♦</div>
        <div className="card-box black">3 ♣</div>
        <div className="card-box black">4 ♠</div>
        <div className="card-box black">5 ♠</div>
        <div className="card-box red">6 ♦</div>
      </div>
    ),
  },
  {
    name: "Three of a Kind (7 to 1)",
    element: (
      <div className="cardholdem-row">
        <div className="card-box red">K ♦</div>
        <div className="card-box black">K ♣</div>
        <div className="card-box black">K ♠</div>
        <div className="cardwhiteholdem red">5 ♠</div>
        <div className="cardwhiteholdem red">9 ♦</div>
      </div>
    ),
  },
  {
    name: "Two pairs (7 to 1)",
    element: (
      <div className="cardholdem-row">
        <div className="card-box red">Q ♦</div>
        <div className="card-box black">Q ♠</div>
        <div className="cardwhiteholdem red">4 ♣</div>
        <div className="card-box red">2 ♠</div>
        <div className="card-box red">2 ♦</div>
      </div>
    ),
  },
  {
    name: "Pair of Aces (7 to 1)",
    element: (
      <div className="cardholdem-row">
        <div className="card-box red">A ♦</div>
        <div className="card-box red">A ♠</div>
        <div className="cardwhiteholdem red">4 ♣</div>
        <div className="cardwhiteholdem red">1 ♠</div>
        <div className="cardwhiteholdem red">Q ♦</div>
      </div>
    ),
  },

  {
    button: <button className="rule-button undo">UNDO</button>,
    name: `Undo button to clear the last bets.`,
  },
  {

    button: <button className="rule-button deal">DEAL</button>,
    name: `Deal button to place your bet and play.`,
  },
  {

    button: <button className="rule-button clearholdem">CLEAR</button>,
    name: `Clear button to remove all placed bets.`,
  },
  {

    button: <button className="rule-button raise">Raise</button>,
    name: `Raise button to Raise the bets.`,
  },
  {

    button: <button className="rule-button fold">FOLD</button>,
    name: `Fold button to Fold the Hand.`,
  },
  {

    button: <button className="rule-button rebetholdem">REBET</button>,
    name: `Play next round with same bets`,
  },
  {

    button: <button className="rule-button d_rebetholdem">REBETX2</button>,
    name: `Play next round with Double of Previous bets.`,
  },
  {

    button: <button className="holdembetpalcedares">ANTE</button>,
    name: `Ante position Ante Amount will be displayed here`,
  },
  {

    button: <button className="holdembetpalcedares">BONUS</button>,
    name: `Bonus position Bonus Amount will be displayed here`,
  },
  {

    button: <button className="holdembetpalcedaresRasise">RAISE</button>,
    name: `Raise position - incase of good card combination , Press the raise button automatically place the bet double of ANTE bet.The 4th and 5th cards are opened, and the winner is revealed`,
  },



]

const tableProps = [
  { title: "Hand Id", key: "handId", isdisplay: true },

  // { title: "Dealer Second Hand", key: "dealerSplit", isdisplay: true, isArray: true, isShowCards: true },
  { title: "PlayerCards", key: "playerCards", isdisplay: true, isArray: true, isShowCards: true },
  { title: "BoardCards", key: "boardCards", isdisplay: true, isArray: true, isShowCards: true },
  { title: "DealerCards", key: "dealerCards", isdisplay: true, isArray: true, isShowCards: true },
  { title: "Ante", key: "anteBetAmount", isdisplay: true, hasSubTitles: true, subTitles: ["Wager", "Win"] },
  { title: "Bonus", key: "bonusBet", isdisplay: true, hasSubTitles: true, subTitles: ["Wager", "Win"] },
  { title: "Raise", key: "call", isdisplay: true, hasSubTitles: true, subTitles: ["Wager", "Win"] },

  { title: "Winner", key: "winner", isdisplay: true },
]


export const MyContextHoldem = createContext();
const Casinoholdem = forwardRef((props, ref) => {

  const boardRef = useRef()
  const bonusref = useRef()
  const controllerRef = useRef()
  const popholdem = useRef(null)
  const [orientation, setOrientation] = useState('windows'); // 'windows', 'portrait', 'landscape'
  // const [infoText, setInfoText] = useState('Your Bet Acceptance is Under Consideration !! Please wait until its Confirmed'); // 'windows', 'portrait', 'landscape'
  const [infoText, setInfoText] = useState('Place your bets on ANTE to start the game.');
  const [betAmount, setBetAmount] = useState(0)
  const [totalbets, settotalbets] = useState(0)
  const [bonusAmount, setbonusAmount] = useState(0)
  const [winanimation, setiswinanimation] = useState(false)
  const [setcasinoholdAnimation, casinoholdAnimation] = useState(false)
  const [isbonuspayout, setisbonuspayout] = useState(false);
  const [istadaAntechip, setistadaAntechip] = useState(false);
  const [istadaBonuschip, seistadaBonuschip] = useState(false);
  const [raiseAmount, setraiseAmount] = useState(0)
  const [finalblinkcards, setfinalblinkcards] = useState([]);
  const [cardblink, setCardblink] = useState(false);
  const [duplicateBetAmount, setDuplicateBetAmount] = useState(0)
  const [Handmessage, setHandmessage] = useState("");
  const [isMuted, setIsMuted] = useState(false);
  const [delaerhand, setdealerHandmessage] = useState("");
  const [winAmount, setWinAmount] = useState(0)
  const [antewinAmount, setanteWinAmount] = useState(0)
  const [bonuswinamount, setbonuswiamount] = useState(0)
  const [bonuspopup, setbonuspopup] = useState(false)
  const [totalwinamount, settotalwin] = useState(0)
  const [isOptionsMenu, setOptionsMenu] = useState(false);
  const [selectedChip, setChipCount] = useState(0)
  // const [prevBetAmount, setPrevBetAmount] = useState(null)
  // const [prevbonusAmount, setprevbonusAmount] = useState(null)
  const [betBtn, setBetBtn] = useState("BET")
  const [Enableclick, setEnableclick] = useState(false)
  const [clearBtn, setClearBtn] = useState("CLEAR")
  const [undoBtn, setUndoBtn] = useState("UNDO")
  const [isBetaction, setisBetaction] = useState(false);
  const [isBonusaction, setisBonusaction] = useState(false);
  const [shouldPulse, setShouldPulse] = useState(true);
  const [bonusactive, setBonusactive] = useState(false);
  const [Raiseactive, setRaiseactivated] = useState(false);
  const [welcomePopup, setenablewelcmpopup] = useState(true);


  // console.log(props,ref)



  useImperativeHandle(ref, () => ({
    checkPreviousGameState,
    updateMessage,
    handleResize: handleResize,
    updatePlayerInfo: (e) => {

      setDuplicateBetAmount(0)
    },
    HoldembetResponse: (e) => { HoldembetResponse(e) },
    HoldemCallreponce: (e) => { HoldemCallreponce(e) },
    HoldemFoldresponce: (e) => { HoldemFoldresponce(e) },



    // paiGowAnteSplitResult
  }));

  useEffect(() => {
    console.log(props.gameState.history)
    console.log(props)
    setisBonusaction(false)
    window.addEventListener('resize', handleResize);
    handleResize(); // initialize
    props.assestsLoaderFunction()
    if (props?.gameState) {
      checkPreviousGameState()
    }

  }, []);



  const detectOrientation = () => {
    const isLandscape = window.innerWidth > window.innerHeight;
    if (window.innerWidth >= 1024) return 'windows';
    return isLandscape ? 'landscape' : 'portrait';
  };

  const handleResize = () => {
    setOrientation(detectOrientation());
  };



  const checkPreviousGameState = () => {

    console.log(props.gameState)
    if (props.gameState?.oldHandId === props.gameState?.handId) {

      if (props.gameState.response.action === "BET") {
        setUndoBtn("")
        boardRef?.current?.prevstatestartDealingCards({ boardCards: props.gameState.response?.boardCards, playerCards: props.gameState.response?.playerCards, dealerCards: props.gameState.response?.dealerCards })
        //   boardRef.current?.setHandMessages(res)
        if (props.gameState.response.bestBoardCards || props.gameState.response.playerBestCards) {
          let finalplayerboardsorted_cards = [...props.gameState.response.bestBoardCards, ...props.gameState.response.playerBestCards]
          setfinalblinkcards(finalplayerboardsorted_cards)

        }
        if (props.gameState?.response?.betAmount > 0) {
          setBetAmount(props.gameState.response.anteBetAmount)
          setbonusAmount(props.gameState.response.bonusBet)
          setShouldPulse(false)
          setisBetaction(false)
          settotalbets(props.gameState.response.betAmount)
          setEnableclick(true)

        }
        if (props.gameState?.response?.bonusWinAmount > 0) {
          setWinAmount(props.gameState.response.bonusWinAmount);


        }



        setInfoText("");
        boardRef.current.setHandMessages(props.gameState.response.playerHand)
        setCardblink(true)


      }


    } else {

      if (props.gameState?.betRequest?.anteBetAmount > 0 || props.gameState?.betRequest?.bonusBet > 0) {

        settotalwin(0)
        setBetBtn("REBET")
        setClearBtn("REBETx2")
        setInfoText('Place your bets on ANTE to start the game.')
        setEnableclick(false)
        setShouldPulse(true)
        setUndoBtn("")
        setisBetaction(true)
        setisBonusaction(false)

      }
      else {
        setBetBtn("")
        setClearBtn("")
        setUndoBtn("")
      }
      // setPrevBetAmount(props.gameState?.response?.betAmount)
    }


  }
  const updateMessage = (message) => {
    setInfoText(message)

  }
  const HoldembetResponse = (res) => {
    // alert("..result")
    console.log(res)

    boardRef?.current?.startDealingCards({ boardCards: res?.boardCards, playerCards: res?.playerCards, dealerCards: res?.dealerCards })
    //   boardRef.current?.setHandMessages(res)

    if (res.bestBoardCards || res.playerBestCards) {
      let finalplayerboardsorted_cards = [...res.bestBoardCards, ...res.playerBestCards]
      console.log(finalplayerboardsorted_cards)
      setfinalblinkcards(finalplayerboardsorted_cards)

    }


    setTimeout(() => {

      if (res.bonusWinAmount > 0) {
        setbonuswiamount(res.bonusWinAmount)
        setbonuspopup(true)

      }

      boardRef.current.setHandMessages(res.playerHand)
      // setCardblink(true)
    }, 5000);
    setInfoText("");
  }

  const HoldemCallreponce = (res) => {
    console.log(res?.dealerSortedCards)
    boardRef?.current?.revealDealerCards({ boardCards: res?.boardCards, dealerCards: res?.dealerCards }, res.playerSortedCards)
    let finalholdemplyrcards = res.dealerSortedCards
    setfinalblinkcards(finalholdemplyrcards)
    setTimeout(() => {
      setCardblink(true)
      setWinAmount(Number(res.totalWinAmount))
      setHandmessage(res.playerHand)
      setdealerHandmessage(res.dealerHand)

      // setBetAmount(res.anteBet);
      // setbonusAmount(res.bonusBet);............commented on 06-10-25
      // setInfoText("")
      setInfoText(res.message)

    }, 3000);
    setTimeout(() => {
      boardRef.current.setHandMessages(res.playerHand, res.dealerHand)
      if (res.winAmount > 0) {
        if (document.getElementById("player_handholdem")) {
          let playerHand = document.getElementById("player_handholdem");
          playerHand.classList.add("hand-strength-blink");

        }
      } else {
        if (document.getElementById("dealer_handholdem")) {
          let dealerHand = document.getElementById("dealer_handholdem");
          dealerHand.classList.add("hand-strength-blink");

        }

      }
    }, 2500);
    setTimeout(() => {
      if (res.winAmount > 0) {
        setanteWinAmount(res.anteWin)
        // setbonuswiamount(res.bonusPayout)
        settotalwin(res.totalWinAmount)
        if (popholdem?.current) {
          popholdem.current.style.display = "block";
        }


        boardRef.current?.playWinGlowSound()
        casinoholdAnimation(true)
        setiswinanimation(true)

      }
      setBetAmount(0);
      setbonusAmount(0);
      setraiseAmount(0);
      setInfoText("")
      if (res.winAmount == 0) {
        updateplayerbalnace()
        settotalbets(0);
      }

    }, 4000);
    setTimeout(() => {
      if (res.winAmount > 0) {
        updateplayerbalnace()
        settotalbets(0);


      }
      if (res.winAmount > 0 && popholdem?.current) {
        popholdem.current.style.display = "none";

      }
      casinoholdAnimation(false)
      setiswinanimation(false)
      // }
      // setInfoText("")

      // setisBetaction(true)
      // setisBonusaction(false)

      // seistadaBonuschip(true)
      // setistadaAntechip(true)
      // setiswinanimation(false)
      setWinAmount(Number(0))
      setanteWinAmount(0)
      setbonuswiamount(0)

      // setShouldPulse(true)
      // setBetBtn("REBET")
      // setClearBtn("REBETx2")
      // setInfoText('Place your bets on ANTE to start the game.')
      // setEnableclick(false)
      // setUndoBtn("")
      // settotalwin(0)

    }, 6500);

  }

  const HoldemFoldresponce = (res) => {
    boardRef?.current?.clearallHoldemcards()
    // setBetBtn("REBET")
    // setClearBtn("REBETx2")
    setEnableclick(false)
    // setisBetaction(true)
    // setisBonusaction(false)
    setBonusactive(false)
    setRaiseactivated(false)
    // setShouldPulse(true)
    setBetAmount(0);
    setbonusAmount(0);
    settotalbets(0);
    setraiseAmount(0);
    setInfoText(res.message)
    updateplayerbalnace()
    setWinAmount(0);
    // setInfoText('Place your bets on ANTE to start the game.')
  }

  const toggleMute = () => {
    const newMuteState = !isMuted;
    setIsMuted(newMuteState);
    boardRef?.current?.toggleMute(newMuteState)
  };
  const updateplayerbalnace = () => {
    props.gamstateHandle();
    // this.setState({betdeductions:0,noupdateblnce:true})

    const body2 = {
      CN: "GET_PLAYER_INFO",
      object: { 
        gameId: Number(props.gameId),
        playerId: Number(props.playerId),
      },
      sessionId: sessionStorage.getItem('sessionId'),
    }
    props.network.sendof(body2);

  }

  const contextValue = {
    finalblinkcards,
    setfinalblinkcards,
    cardblink,
    setCardblink,
    Handmessage,
    setHandmessage,
    delaerhand,
    setdealerHandmessage,
    raiseAmount, setraiseAmount,
    betAmount, setBetAmount,
    bonusAmount, setbonusAmount,
    betBtn, setBetBtn,
    clearBtn, setClearBtn,
    undoBtn, setUndoBtn,
    selectedChip, setChipCount,
    infoText, setInfoText,
    winAmount, setWinAmount,
    totalbets, settotalbets,
    duplicateBetAmount, setDuplicateBetAmount,
    istadaBonuschip, seistadaBonuschip,
    istadaAntechip, setistadaAntechip,
    shouldPulse, setShouldPulse,
    isBonusaction, setisBonusaction,
    isBetaction, setisBetaction,
    bonusactive, setBonusactive,
    Raiseactive, setRaiseactivated,
    Enableclick, setEnableclick,
    isbonuspayout, setisbonuspayout,
    bonuspopup, setbonuspopup,
    bonuswinamount, setbonuswiamount

  };

  return (
    <div
      id="holdemGameBoard">
      <MyContextHoldem.Provider value={contextValue}>
        <CasinoholdemGameControllers
          ref={controllerRef}
          language={props.language}
          chipsArray={props.holdem_chipValues}
          playChipSound={boardRef.current?.playChipSound}
        ></CasinoholdemGameControllers>

      </MyContextHoldem.Provider>


      <MyContextHoldem.Provider value={contextValue}>
        <CainoholdemGameBoard
          ref={boardRef}
          minBetAmt={props.minBetAmt}
          maxBetAmt={props.maxBetAmt}
          language={props.language}
          chipsArray={props.holdem_chipValues}
          balance={props.balance}
          network={props.network}
          playerId={props.playerId}
          gameId={props.gameId}
          gameState={props.gameState}
        // setraiseAmount={setraiseAmount}
        ></CainoholdemGameBoard>
      </MyContextHoldem.Provider>

      <div>
        <span id='optionMenuholdem' onClick={() => { boardRef.current?.playMenuSound(); setOptionsMenu(true) }}><FaBars /></span>
        <div className="userInfoholdem">
          <img src={user_img} className="iconholdem" />
          <span>{props.user}</span>
        </div>
        <div className="balanceInfoholdem">
          <img id="balance_iconholdem" src={balance_img} className="iconholdem" />
          <span>{Number(props.balance - duplicateBetAmount).toFixed(2)}</span>
        </div>
        <div className="betInfoholdem">
          <img src={betChip_img} className="iconholdem" />
          <span>{Number(totalbets.toFixed(2))}</span>

        </div>
        <div className="winInfoholdem">
          <img src={winCup_img} className="iconholdem" />

          <span>{Number(winAmount.toFixed(2))}</span>
        </div>

        <div id="infoContainerholdem">
          <span id="infoPaiGowholdem" className='infoPaiGowholdem' style={{ "--infoTextLength": infoText?.length + "ch" }}>{infoText}</span>
        </div>


        <div id="playerHandDetailsholdem">
          <div id="player_idholdem" >P ID: {props.playerId}</div>
          <div id="hand_idholdem" >Hand ID: {props.gameState.handId}</div>
        </div>
        <img id='muteholdem' src={isMuted ? muteImgholdem : SoundImgholdem} height={isMuted && "70px"} onClick={toggleMute} />


        {(antewinAmount > 0) && (
          <div className="winpopoholdem" ref={popholdem}>
            <div className="popBorderholdem">


              <br />


              {totalwinamount > 0 && (
                <div>
                  <span className="totalwinholdem">🎉Congratulations! You won: {totalwinamount}🎉</span>
                </div>
              )}

            </div>
          </div>
        )}

        {setcasinoholdAnimation && <WinAnimation showWinAnimation={winanimation} amount={winAmount} />}



      </div>
      {
        isOptionsMenu && <OptionsMenu GameRules={GameRules} history={props.gameState?.history} tableProps={tableProps} minBetAmt={props.minBetAmt} maxBetAmt={props.maxBetAmt} tableclass="historyTableholdem" headClass="" bodyClass="" openOptions={() => { setOptionsMenu(false) }} />
      }

      <PayoutInfoholdem />
      {bonuspopup && (
        <MyContextHoldem.Provider value={contextValue}>
          <Bonuspopup ref={bonusref} isbonuspopup={bonuspopup} bonusAmount={bonuswinamount}></Bonuspopup>
        </MyContextHoldem.Provider>

      )}

      {welcomePopup && <div className="iosFetchSounds" id="iospopup" onClick={(e) => setenablewelcmpopup(false)}>
        <div className="popupTooLong">
          <div className="mt-2">{props.language.Wel_CH}</div>
          {props.language?.OK_Btn}
          <br></br>
          <br></br>
          <div className="fd">
            <button className="btn_iosPopup" > OK </button>
            <br></br>
          </div>
        </div>
      </div>}
    </div>
  );
});

export default (Casinoholdem);